/**
 * Login
 */
import React, { useState, useEffect, useCallback } from 'react';
import { Axios } from '../utils/UtilityFunctions'

import { TextField, Grid, Container, InputLabel, FormControl, Select, MenuItem,Link  } from '@material-ui/core'
import ArrowDownIcon from "../components/ArrowDownIcon";
import { makeStyles } from '@material-ui/core/styles'
import { EmailOutlined, LockOpen, LockOutlined } from '@material-ui/icons';
import { useHistory } from "react-router-dom";

import { DataGrid } from '@material-ui/data-grid';

import QuoteDrawer from './QuoteDrawer'
import _ from 'lodash'



const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    formControl: {
        margin: 1,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: 2,
    },
});


const columns = [
    // { field: "id", headerName: 'ID', width: 70 },
    // {
    //     field: "_customer", headerName: 'Customer', width: 170,
    //     valueGetter: (params) => params.row.customer.customerName
    // },
    {
        field: "tradeInDate", headerName: 'Trade In Date', width: 170,
        valueGetter: (params) => new Date(params.row.tradeInDate)
    },
    {
        field: "_item", headerName: 'Device', width: 250,
        valueGetter: (params) => params.row.item.name
    },
    // {
    //     field: 'zip', headerName: 'Zip', width: 100,
    //     valueGetter: (params) => params.row?.ctiQuoteParent?.zip
    // },
    { field: "originalDeviceId", headerName: 'IMEI/ SN', width: 200 },
    {
        field: 'phone', headerName: 'Phone #', width: 150,
        valueGetter: (params) => params.row?.ctiQuoteParent?.phone
    },
    {
        field: 'email', headerName: 'Email', width: 250,
        valueGetter: (params) => params.row?.ctiQuoteParent?.email
    },


    // { field: "_contact", headerName: '_contact', width: 170 },
    // { field: "rawData", headerName: 'rawData', width: 70 },
    // { field: "originalDeviceId", headerName: 'originalDeviceId', width: 170 },
    // { field: "itemName", headerName: 'IitemName', width: 170 },

    // { field: "deviceId", headerName: 'deviceId', width: 170 },
    // { field: "pcsNegotiatedValue", headerName: 'pcsNegotiatedValue', width: 70 },
    {
        field: "_deviceProcessingState", headerName: 'Status', width: 170,
        valueGetter: (params) => params.row.deviceProcessingState.name
    },

    {
        field: 'trackingNumber', headerName: 'trackingNumber', width: 170,
        // valueGetter: (params) => params.row?.ctiQuoteParent?.trackingNumber,
        renderCell: (CellParams) => {
            // console.log('CellParams', CellParams)
            return  <Link href={CellParams.row?.ctiQuoteParent?.trackingDetailsUrl} >
            {CellParams.row?.ctiQuoteParent?.trackingNumber}
          </Link>
        }
    },
    {
        field: 'ShippingLabel', 
        headerName: 'Shipping Label', width: 170,
        // valueGetter: (params) => params.row?.ctiQuoteParent?.trackingNumber,
        renderCell: (CellParams) => {
            // console.log('CellParams', CellParams)
            return  <Link href= {CellParams.row?.ctiQuoteParent?.trackingLink} >
            Shipping Label
          </Link>
        }
    },

    {
        field: 'hello',
        headerName: 'Trade in Details',
        width: 200,
        renderCell: (CellParams) => {
            // console.log('CellParams', CellParams)
            return <QuoteDrawer row={CellParams.row} />
        }
    }


];



const getData = async (filters) => {
    console.log('getData', filters)
    let quotes = await Axios('POST', '/quote/getQuotes', { filters });
    console.log(quotes.data)
    return quotes.data.data
}



export default function QuoteTable() {


    const classes = useStyles();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [rowsData, setRowsdata] = useState([]);
    const [emailFilter, setEmailFilter] = useState('');

    const history = useHistory();
    // const getQuotes = useCallback(async () => {
    //     // do something!

    //     // setRowsdata(await getData({ email: emailFilter }))
    //     _.debounce( async () => {
    //         console.log('debounce', 'emailFilter')

    //         setRowsdata(await getData({ email: emailFilter }))
    //     }, 5000, {leading: true})()

   

    // }, []);

  


    useEffect(() => {
        const quotes = async () => setRowsdata(await getData({ email: emailFilter }))
        quotes()
      
        // return () => {  };
    }, [emailFilter]);


    const headerClickHandler = (ColParams) => {
        console.log(ColParams)
    }
    const pageChangeHandler = (PageChangeParams) => {
        setPage(PageChangeParams.page)
        // console.log(PageChangeParams)
    }

    const handleChange = (e) => {
        // console.log('e.target', e.target)
        setEmailFilter(e.target.value)
    }


    return (
        <>
            <Container component="main" maxWidth="xl" className={classes.main}>

                <TextField
                    id="outlined-basic"
                    label="Search"
                    variant="outlined"
                    onChange={handleChange}
                    value={emailFilter}
                />
                {/* <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value=''
                        onChange={handleChange}
                        label="Age"
                        name="age"
                        IconComponent={ArrowDownIcon}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        <MenuItem value={10}>Ten</MenuItem>
                        <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                </FormControl> */}

                <div style={{ height: '500', width: '100%' }}>
                    <DataGrid
                        onColumnHeaderClick={headerClickHandler}
                        onPageChange={pageChangeHandler}
                        rows={rowsData}
                        columns={columns}
                        pageSize={pageSize}
                        page={page}
                        rowsPerPageOptions={[50, 100, 200]}
                        paginationMode='client'
                        autoHeight
                    />
                </div>

            </Container>

        </>
    );
}

